export default "__VITE_ASSET__34792662__"